import Contacts from "../utils/services/contactService";
import crudTemplate from "../templates/crudTemplate";
import massTemplate from "../templates/massTemplate";
let crud = crudTemplate(Contacts);

function prepareItem(item) {
  item.compiledName = item.organization_name
    ? item.organization_name
    : item.family_name + " " + item.given_name;
  return item;
}

const state = {
  ...crud.state,
  users: []
};

const getters = {
  ...crud.getters,
  getItem(state) {
    let item = crud.getters.getItem(state);
    return prepareItem(item);
  },
  getList(state) {
    let list = crud.getters.getList(state);
    return list.map(prepareItem);
  },
  getUsers(state) {
    return state.users;
  }
};

const actions = {
  ...crud.actions,

  getUsers({ commit }, { id }) {
    return Contacts.users.get({ id }, users =>
      commit("setUsers", {
        users
      })
    );
  },
  addUser(_, { id, email, onSuccess = () => {} }) {
    return Contacts.users.add({ id, email }, onSuccess);
  },
  deleteUser(_, { id, user_id, onSuccess = () => {} }) {
    return Contacts.users.delete({ id, user_id }, onSuccess);
  },
  ...massTemplate(Contacts, "move").actions,
  ...massTemplate(Contacts, "copy").actions
};

const mutations = {
  ...crud.mutations,
  setUsers(state, { users }) {
    state.users = users;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  prepareContact: prepareItem
};
